export default __webpack_public_path__ + "static/cann-9838baf959e7f17ab03f7cdda3573f4a.jpg";